import React from 'react';

interface SegmentedControlItem<T extends string> {
  value: T;
  label: React.ReactNode;
  disabled?: boolean;
}

export interface SegmentedControlProps<T extends string> {
  value: T;
  onChange: (value: T) => void;
  items: ReadonlyArray<SegmentedControlItem<T>>;
  className?: string;
  size?: 'sm' | 'md';
}

export const SegmentedControl = <T extends string>({
  value,
  onChange,
  items,
  className = '',
  size = 'md',
}: SegmentedControlProps<T>) => {
  const sizeClasses = size === 'sm' ? 'min-h-[44px] p-1 text-sm' : 'min-h-[50px] p-1.5 text-sm';
  const buttonSizeClasses = size === 'sm' ? 'px-3 py-2.5 text-sm' : 'px-4 py-2.5 text-sm';

  return (
    <div
      className={`inline-flex rounded-full border border-[#D7D3CC] bg-[#F4F0EA] ${sizeClasses} ${className}`.trim()}
      role="group"
    >
      {items.map((item) => {
        const isActive = item.value === value;

        return (
          <button
            key={item.value}
            type="button"
            onClick={() => onChange(item.value)}
            disabled={item.disabled}
            aria-pressed={isActive}
            className={`rounded-full font-medium transition ${buttonSizeClasses} ${
              isActive
                ? 'bg-[#FFFFFF] text-[#1A1714] shadow-[0_6px_18px_rgba(26,23,20,0.08)]'
                : 'text-[#6B6560] hover:text-[#1A1714]'
            }`}
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
};
